import React from 'react';

import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import clsx from 'clsx';

import { CoreProps } from '../../types';
import { withCoreProps } from '../../withCoreProps';

export const AppBar = withCoreProps<AppBarProps>(
  ({ children, className, ...props }: React.PropsWithChildren<AppBarProps>) => {
    const clsxClass = clsx(className);

    return (
      <MuiAppBar {...props} className={clsxClass}>
        {children}
      </MuiAppBar>
    );
  },
);

export interface AppBarProps extends MuiAppBarProps, CoreProps {}
